import L from 'leaflet';
export class MercatorProjection {
    private pixelOrigin: L.Point | null = null;
    private pixelsPerLonDegree: number = 0;
    private pixelsPerLonRadian: number = 0;

    //#region helpers
    public fromLatLng(point: any) {
        this.created();
        const latlng = [point.lat, point.lng];
        const result = this.fromLatLngToPoint(latlng);
        return { x: result.x, y: result.y };
    }

    public toLatLng(point: any) {
        this.created();
        const result = this.fromPointToLatLng(point);
        return { lat: result[0], lng: result[1] };
    }
    //#endregion

    public fromLatLngToPoint(latLng: any, opt_point: any = null) {
        this.created();
        const point = opt_point || L.point(0, 0);
        const origin = this.pixelOrigin!;
        point.x = origin.x + latLng[1] * this.pixelsPerLonDegree;
        const siny = this.bound(Math.sin(this.degreesToRadians(latLng[0])), -0.9999, 0.9999);
        point.y = origin.y + 0.5 * Math.log((1 + siny) / (1 - siny)) * -this.pixelsPerLonRadian;
        return point;
    }

    public fromPointToLatLng(point: any) {
        this.created();
        const origin = this.pixelOrigin;
        const lng = (point.x - origin!.x) / this.pixelsPerLonDegree;
        const latRadians = (point.y - origin!.y) / -this.pixelsPerLonRadian;
        const lat = this.radiansToDegrees(2 * Math.atan(Math.exp(latRadians)) - Math.PI / 2);
        return [lat, lng];
    }

    private created() {
        const TILE_SIZE = 256;
        this.pixelOrigin = L.point(TILE_SIZE / 2, TILE_SIZE / 2);
        this.pixelsPerLonDegree = TILE_SIZE / 360;
        this.pixelsPerLonRadian = TILE_SIZE / (2 * Math.PI);
    }

    private bound(value: any, opt_min: any, opt_max: any) {
        if (opt_min !== null) {
            value = Math.max(value, opt_min);
        }
        if (opt_max !== null) {
            value = Math.min(value, opt_max);
        }

        return value;
    }

    private degreesToRadians(deg: number) {
        return deg * (Math.PI / 180);
    }

    private radiansToDegrees(rad: number) {
        return rad / (Math.PI / 180);
    }
}
